import { useAuth } from "@/contexts/useAuth";
import { cn } from "../../lib/utils";
import { Link, useLocation } from "react-router-dom";
export function LessonTabs({ courseId, lessonId }) {
	const { pathname } = useLocation();
	const { user } = useAuth();

	const tabs = [
		{
			name: "Lesson",
			href: `/dashboard/courses/${courseId}/lessons/${lessonId}`,
		},
		{
			name: "Notes",
			href: `/dashboard/courses/${courseId}/lessons/${lessonId}/notes`,
			authOnly: true,
		},
		{
			name: "Quiz",
			href: `/dashboard/courses/${courseId}/lessons/${lessonId}/quizzes`,
		},
		// {
		// 	name: "Flashcards",
		// 	href: `/dashboard/courses/${courseId}/lessons/${lessonId}/flashcards`,
		// },
	];

	return (
		<div className="border-b">
			<nav className="flex space-x-4" aria-label="Tabs">
				{tabs
					.filter((tab) => !(tab.authOnly && !user))
					.map((tab) => {
						const isActive =
							pathname === tab.href ||
							pathname.endsWith(`${tab.href}/`);

						return (
							<Link
								key={tab.name}
								to={tab.href}
								className={cn(
									"px-3 py-2 text-sm font-medium",
									isActive
										? "border-b-2 border-primary text-primary"
										: "text-muted-foreground hover:text-foreground"
								)}
								aria-current={isActive ? "page" : undefined}>
								{tab.name}
							</Link>
						);
					})}
			</nav>
		</div>
	);
}
